import { render, staticRenderFns } from "./ListGroupItem.vue?vue&type=template&id=53704d92&scoped=true&"
import script from "./ListGroupItem.vue?vue&type=script&lang=js&"
export * from "./ListGroupItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53704d92",
  null
  
)

export default component.exports